export default () => ({
  el: undefined,
  timer: undefined,
  autoRemove: false,
  init() {
    mrp.log(`RxToast init`);
    this.el = this.$el;
    if (this.el.getAttribute("data-auto-remove") === "true") {
      this.autoRemove = true;
    }
    if (this.autoRemove) {
      this.timer = setTimeout(() => {
        this.el.remove();
      }, 4000);
    }
  },
  dismiss() {
    mrp.log(`RxToast dismiss`);
    this.el.remove();
  },
  destroy() {
    clearTimeout(this.timer);
  },
});
